var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16797 6.66671H9.5013V5.33337H8.16797V6.66671ZM8.16797 9.33337H9.5013V8.00004H8.16797V9.33337ZM9.5013 13.3334V10.6667H8.16797V13.3334H6.16797V4.66671H8.16797H9.5013H11.5013V13.3334H9.5013ZM14.168 12V13.3334H12.8346V3.33337H11.5013H9.5013V1.33337H8.16797V3.33337H6.16797H4.83464V13.3334H3.5013V12H2.16797V13.3334V14.6667H4.83464H6.16797H11.5013H12.8346H15.5013V13.3334V12H14.168Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffices);
export default __webpack_public_path__ + "static/media/Offices.159032488939849c4f5aea0a269cb6fb.svg";
export { ForwardRef as ReactComponent };